export class GoogleWorkspaceSharedDriveSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<SaasRestoreItem>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "SaasRestoreMode",
            "format": ""
        },
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        },
        {
            "name": "preserveFolderHierarchy",
            "baseName": "preserveFolderHierarchy",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceSharedDriveSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
